export const pointerConstants = {
	ELEMENT_HOVER_STATE: "ELEMENT_HOVER_STATE",
	ELEMENT_SCROLL_STATE: "ELEMENT_SCROLL_STATE",
	ELEMENT_CLICK_STATE: "ELEMENT_CLICK_STATE",
	ELEMENT_SLIDE_STATE: "ELEMENT_SLIDE_STATE",
};
